import { css, cx } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { type PaymentMethodCode, paymentMethodCodes } from '../../../constants/paymentMethods';

const { PAYPAL, PAYPAL_PAY_LATER } = paymentMethodCodes;

const hiddenStyles = css`
  display: none;
`;

const payPalButtonStyles = css`
  line-height: 0;
  min-width: 14.5rem;
  position: relative;
  width: 100%;
  z-index: 1;

  @media (min-width: ${breakpoints._768}) {
    margin: 0 auto;
    max-width: 22.5rem;
  }

  .paypal-buttons-disabled {
    /* !important added to override styling from paypal */
    /* stylelint-disable-next-line declaration-no-important */
    opacity: unset !important;
  }
`;

interface PayPalButtonPortalRootProps {
  paymentMethodCode: PaymentMethodCode;
  shouldShow: boolean;
}

const PayPalButtonPortalRoot = ({ paymentMethodCode, shouldShow }: PayPalButtonPortalRootProps) => {
  return (
    <>
      <div
        className={cx(payPalButtonStyles, {
          [hiddenStyles]: !shouldShow || paymentMethodCode !== PAYPAL,
        })}
        data-testid="paypal-button"
        id="paypal-button-portal"
      />

      <div
        className={cx(payPalButtonStyles, {
          [hiddenStyles]: !shouldShow || paymentMethodCode !== PAYPAL_PAY_LATER,
        })}
        data-testid="paypalpaylater-button"
        id="paypalpaylater-button-portal"
      />
    </>
  );
};

export default PayPalButtonPortalRoot;
